import { FilterConfig } from '../../../../model/filter';
import { ActionType } from '../../../../utils/enums';
import { Domain } from '../../../../dtos/version.dto';

export const domainsFiltersConfig: FilterConfig<Domain> = {
    searchBox: { placeholder: 'Search Domain', byFields: ['name', 'domainUrl']},
    radioButtons: {
        defaultSelectionIndex: 0,
        options: [
            { label: 'All', filterFn: () => true },
            { label: 'Blocked', filterFn: (domain: Domain) => domain.domainAction === ActionType.BLOCK },
            { label: 'Allowed', filterFn: (domain: Domain) => domain.domainAction === ActionType.ALLOW }
        ]
    }
};